import { combineReducers } from "redux";
import cancelSubscription from "./cancel-subscription";
import reactivateSubscription from "./reactivate-subscription";
import editSubscription from "./edit-subscription";
import subscriptionAdmin from "./get-subscription";


const reducer = combineReducers({
    cancelSubscription,
    reactivateSubscription,
    editSubscription,
    subscriptionAdmin
});

export default reducer;
